import { createSelector } from 'reselect';

export const routerStateSelector = state => state.router;

export const currentLocationSelector = createSelector(
  routerStateSelector,
  router => router.location.pathname
);


// WEBPACK FOOTER //
// ./src/app/modules/navigation/store/selectors.ts